import { makeStyles } from "@material-ui/styles";

const styles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },
  forGotPassword: {
    marginTop: theme.spacing(2),
    color: "#198BDE",
    paddingTop: theme.spacing(2),
    '&:hover': {
      textDecoration: "underline"
    }
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: "100%",
    backgroundColor: "#1E77B8",
  },
}));

export default styles;
